import { ProductHelper } from '#/global/helper/Product/ProductHelper'

export default {
    cz: {
        title: 'Pracujte bez starostí',
        subText: (
            <>
                Sjednejte si službu
                {' '}
                <a href="/garance" target="_blank">Garance</a>
                {' '}
                a pracujte bez obav z poškození půjčeného produktu.
            </>
        ),
        price: (price: number, unit: string) => (
            <>
                <span>Cena služby:</span>
                <b>{ProductHelper.formatPrice(price, 'CZK')}</b>
                <span>
                    za
                    {' '}
                    {unit}
                </span>
                <span>s DPH</span>
            </>
        ),
        button: 'Chci garanci',
        agreed: 'Sjednáno',
        error: 'Nepodařilo se přidat Granci k položce.',
    },
    sk: {
        title: 'Pracujte bez starostí',
        subText: (
            <>
                Dohodnite si službu
                {' '}
                <a href="/garance" target="_blank">Garancia</a>
                {' '}
                a pracujte bez obáv z poškodenia požičaného produktu.
            </>
        ),
        price: (price: number, unit: string) => (
            <>
                <span>Cena služby:</span>
                <b>{ProductHelper.formatPrice(price, 'EUR')}</b>
                <span>
                    za
                    {' '}
                    {unit}
                </span>
                <span>s DPH</span>
            </>
        ),
        button: 'Chcem garanciu',
        agreed: 'Dohodnuté',
        error: 'Nepodarilo sa pridať Garanciu k položke.',
    },
}
